<template>
  <div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import API from '@/classes/API';

export default {
  props: {
  },
  components: {
  },
  data() {
    return {
      snippet: null,
      loaded: false,
      signedin: false,
      error: false,
      timeoutReference: null,
    };
  },
  created() {
    this.timeoutReference = setInterval(this.checkForCancellation, (1 * 60 * 1000));
    this.checkForCancellation();
  },
  destroyed() {
    clearInterval(this.timeoutReference);
  },
  methods: {
    async checkForCancellation() {
      console.log('Checking for cancellation...');
      const orderId = this.$route.query.order || 0;
      let klarnaId = this.$route.query.checkout_session_id || '';
      if (!klarnaId) {
        klarnaId = window.__KLARNA_CURRENT_ORDER_ID || ''; // eslint-disable-line
      }
      const { cancelled } = await API.get(`/orders/check-for-system-cancellation/${orderId}?checkout_session_id=${klarnaId}`);

      if (cancelled) {
        clearInterval(this.timeoutReference);
        this.openModal(['BookingCancelled']);
      }
    },
    ...mapMutations([
      'openModal',
      'clearCart',
      'setUser',
    ]),
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.center
  text-align: center
  margin-top 25px
  margin-bottom 15px
</style>



// WEBPACK FOOTER //
// OrderCheckForCancellation.vue?96b608e6